import React from 'react'
import './LockPortraitScreen.component.css'
import { useTranslation } from 'react-i18next'

const LockPortraitScreenComponent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <div id='animation-container'>
        <img id='device-icon' src='/assets/images/RotateScreenIcon.svg' alt='RotateDevice' />
        <p id='message'>{t('fullChart.featureWorksInPortraitMode')}</p>
      </div>
    </>
  )
}

export default LockPortraitScreenComponent
